import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 从环境变量获取 API 基础路径
const apiBaseUrl = process.env.VUE_APP_BASE_API || ''

// 调试日志
console.log('=== API Base URL:', apiBaseUrl)
console.log('=== VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API)

// 创建 axios 实例
// 开发环境下 baseURL 为空，通过 webpack-dev-server 代理转发
// 生产环境下使用环境变量配置的 API 地址
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : apiBaseUrl,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    
    const currentLang = localStorage.getItem('lang') || 'zh'
    config.headers['Lang'] = currentLang === 'en' ? 'en' : 'zh-cn'
    
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    if (typeof res !== 'object' || res === null) {
      const errorMsg = typeof res === 'string' ? res : '返回格式错误'
      Message({
        message: errorMsg,
        type: 'error',
        duration: 5000
      })
      return Promise.reject(new Error(errorMsg))
    }

    if (Array.isArray(res)) {
      return res
    }

    if (res.success === true || res.code === 200 || res.code === 0) {
      return res
    } else {
      const errorMsg = res.msg || '请求失败'
      Message({
        message: errorMsg,
        type: 'error',
        duration: 3000
      })

      if (res.code === 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }

      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    let message = '网络错误，请稍后重试'
    
    if (error.response) {
      const responseData = error.response.data
      message = responseData && responseData.msg ? responseData.msg : 
                responseData && responseData.message ? responseData.message : 
                responseData && responseData.error ? responseData.error : 
                message
      
      if (typeof responseData === 'string') {
        message = responseData
      }
      
      error.msg = message

      if (error.response.status === 401) {
        localStorage.removeItem('token')
        router.push('/login')
      }
    } else if (error.request) {
      error.msg = '服务器无响应，请检查网络连接'
    }

    Message({
      message: error.msg || '网络错误，请稍后重试',
      type: 'error',
      duration: 5000
    })

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js